export enum NotificationType {
  SUCCESS = "success",
  ERROR = "error",
  WARNING = "warning",
  ADD = "add",
  LOGIN = "login",
}
